import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import {
  Header,
  HeroSection,
  DoctorProfile,
  Qualifications,
  ClinicPhotos,
  GoogleReviews,
  ResearchInterests,
  Specialties,
  ContactSection,
  Footer
} from './components';
import SpecialtyPage from './SpecialtyPage';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <DoctorProfile />
      <Qualifications />
      <ClinicPhotos />
      <ResearchInterests />
      <Specialties />
      <GoogleReviews />
      <ContactSection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/specialty/:slug" element={<SpecialtyPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;